import { render } from "./header.vue?vue&type=template&id=15b71aa0&scoped=true"
import script from "./header.vue?vue&type=script&lang=js"
export * from "./header.vue?vue&type=script&lang=js"

import "./header.vue?vue&type=style&index=0&id=15b71aa0&lang=less&scoped=true"
import "./header.vue?vue&type=style&index=1&id=15b71aa0&lang=css"

import exportComponent from "/root/workspace/cinema-admin_TXA8/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15b71aa0"]])

export default __exports__